import React, { useState } from 'react'
import { RxCross2 } from 'react-icons/rx'
import { FaUser } from "react-icons/fa6";
import { TbAlertTriangleFilled } from 'react-icons/tb';
import { HiOutlineBars3 } from "react-icons/hi2";
import { IoIosMail, IoMdCheckmark } from "react-icons/io";
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { FaPhone } from "react-icons/fa6";
import axios from 'axios';
import API from '../../../../utils/API';
// import { FaCalendar } from "react-icons/fa";
import LoadLottie from '../../loadLottie';
import sucess from "../../../../json/sucess.json";
import { toast } from 'react-toastify';
import starter from "../../../images/surge-collges/starter.webp"
import growth from "../../../images/surge-collges/growth.webp"
import scale from "../../../images/surge-collges/scale.webp"
import { IoTrophyOutline, } from "react-icons/io5";
import { RiGraduationCapLine, RiShieldFlashLine, RiPresentationLine, RiMedalLine } from "react-icons/ri";
import { LuHandshake, LuMic, LuSquareUserRound, LuTarget } from "react-icons/lu";

export default function SurgeCollegeForm() {
    const [founderName, setFounderName] = useState("");
    const [institutionName, setInstitutionName] = useState("");
    const [email, setEmail] = useState("");
    const [number, setNumber] = useState("");
    const [designation, setDesignation] = useState("");
    const [date, setDate] = useState("");
    const [whyJoin, setWhyJoin] = useState("");
    const [location, setLocation] = useState("");

    const [isFounderName, setIsFounderName] = useState(false);
    const [isEmail, setIsEmail] = useState(false);
    const [isNumber, setIsNumber] = useState(false);
    const [isInstitutionName, setIsInstitutionName] = useState(false);
    const [isDesignation, setIsDesignation] = useState(false);
    const [isLocation, setIsLocation] = useState(false);
    const [isWhyJoin, setIsWhyJoin] = useState(false);
    const [isDate, setIsDate] = useState(false);
    const [isPay, setIsPay] = useState(false);

    const [founderNameError, setFounderNamError] = useState("");
    const [institutionNameError, setInstitutionNameError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [numberError, setNumberError] = useState("");
    const [designationError, setDesignationError] = useState("");
    const [dateError, setDateError] = useState("");
    const [whyJoinError, setWhyJoinError] = useState("");
    const [locationError, setlocationError] = useState("");


    const [isFounderNameEnter, setIsFounderNameEnter] = useState(false);
    const [isEmailEnter, setIsEmailEnter] = useState(false);
    const [isNumberEnter, setIsNumberEnter] = useState(false);
    const [isInstitutionNameEnter, setIsInstitutionNameEnter] = useState(false);
    const [isDesignationEnter, setIsDesignationEnter] = useState(false);
    const [isLocationEnter, setIsLocationEnter] = useState(false);
    const [isWhyJoinEnter, setIsWhyJoinEnter] = useState(false);
    const [isDateEnter, setIsDateEnter] = useState(false);

    const [isAlready, setIsAlready] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);


    const invalidCharsRegex = /[<>'/\\;’”:{}[\]|+=\-_()*&^%$#!~`]/;

    const [countryCode, setCountryCode] = useState({});

    const [scriptLoaded, setScriptLoaded] = useState(false);

    const plans = [
        {
            id: 'Starter',
            title: 'Starter',
            price: '₹3,00,000',
            icon: starter,
            Internships: "25 Students",
            events: "1 Campus level",
            trainingProgram: "1 Track (Dev/Testing/Design)",
            placement: "1 (DSA OR Resume Clinic)",
            entrepreneurship: "2 mentorship sessions",
            facultyDevelopment: "1 FDP",
            certifications: "L1 only",
            lectures: "1 Founder Lecture",
            HRs: "1 HR virtual session",
        },
        {
            id: 'Growth',
            title: 'Growth',
            price: '₹5,00,000',
            icon: growth,
            Internships: "50 Students",
            events: "1 Institutional",
            trainingProgram: "2 Tracks (choose)",
            placement: "2 (choose)",
            entrepreneurship: "1 Startup Bootcamp",
            facultyDevelopment: "2 FDPs",
            certifications: "L1 + L2",
            lectures: "3 Founder Lectures",
            HRs: "10+ HRs (virtual drive) ",
        },
        {
            id: 'Premium',
            title: 'Premium',
            price: '₹10,00,000',
            icon: scale,
            Internships: "100 Students",
            events: "2 National level",
            trainingProgram: "3 Tracks (Dev, Testing, Design, AI/ML)",
            placement: "4 (DSA, Aptitude, Resume, Communication)",
            entrepreneurship: "Incubation Hub + 2 Bootcamps",
            facultyDevelopment: "4 FDPs",
            certifications: "L1 + L2 + L3",
            lectures: "6 Founder Lectures",
            HRs: "25+ HRs (career fair)",
        },
    ];


    const handleNext = () => {
        if (isEmail && isFounderName && isInstitutionName && isNumber && isDesignation && isLocation && isWhyJoin && !isDate) {
            if (!date.trim()) {
                setDateError('Please select any one option')
            } else {
                if (isDateEnter) {
                    handleSubmit()
                } else {
                    handleNolicencesSubmit();
                }
            }
        }
        else if (isEmail && isFounderName && isInstitutionName && isNumber && isDesignation && isLocation && !isWhyJoin) {
            if (!whyJoin.trim()) {
                setWhyJoinError('Please select any one option')
            } else {
                if (isWhyJoinEnter) {
                    setIsWhyJoin(true)
                } else {
                    handleStartSubmit()
                }
            }
        }
        else if (isEmail && isFounderName && isInstitutionName && isNumber && isDesignation && !isLocation) {
            if (!location.trim()) {
                setlocationError('Please fill in this')
                // }
                // else if (invalidCharsRegex.test(location)) {
                //     setDesignationError("invalid special characters")
            } else {
                if (isLocationEnter) {
                    setIsLocation(true)
                } else {
                    handleAdditionalSubmit()
                }
            }
        }
        else if (isEmail && isFounderName && isInstitutionName && isNumber && !isDesignation) {
            if (!designation.trim()) {
                setDesignationError('Please fill in this')
            } else {
                if (isDesignationEnter) {
                    setIsDesignation(true)
                } else {
                    handleRoleSubmit()
                }
            }
        }
        else if (isEmail && isFounderName && isNumber && !isInstitutionName) {
            if (!institutionName.trim()) {
                setInstitutionNameError('Please fill in this')
            } else {
                if (isInstitutionNameEnter) {
                    setIsInstitutionName(true)
                } else {
                    handleCompanyNameSubmit()
                }
            }
        }
        else if (isEmail && isFounderName && !isNumber) {
            const phoneUtil = PhoneNumberUtil.getInstance();
            const phoneWithoutPlus = number.startsWith(`+${countryCode?.dialCode}`) ? number.slice(countryCode?.dialCode?.length + 1) : number;
            let isValid = false;
            try {
                const parsedPhone = phoneUtil.parse(number, countryCode?.iso2);
                isValid = phoneUtil.isValidNumber(parsedPhone);
            } catch (error) {
                isValid = false;
            }
            if (!isValid || phoneWithoutPlus === "") {
                setNumberError("Hmm... that number doesn't look right")
            } else {
                if (isNumberEnter) {
                    setIsNumber(true)
                } else {
                    handleNumberSubmit()
                }
            }
        }
        else if (isEmail && !isFounderName) {
            if (!founderName.trim()) {
                setFounderNamError('Please fill in this')
            }
            else if (invalidCharsRegex.test(founderName)) {
                setFounderNamError("invalid special characters")
            }
            else {
                if (isFounderNameEnter) {
                    setIsFounderName(true)
                } else {
                    handleNameSubmit()
                }
            }
        }
        else if (!isEmail) {
            // const gmailRegex = /^[^\s@]+@[^\s@]+\.[a-z]{1,}$/i;
            const gmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,}$/i;
            const invalidCharsRegex1 = /[^a-zA-Z0-9.@_-]/;
            if (email === "") {
                setEmailError('Please fill in this');
            }
            else if (invalidCharsRegex1.test(email)) {
                setEmailError("invalid special characters")
            }
            else if (!gmailRegex.test(email)) {
                setEmailError("Hmm... that email doesn't look right");
            } else {
                // handleCheckEmail()
                if (isEmailEnter) {
                    setIsEmail(true)
                } else {
                    handleEmailSubmit()
                }
            }
        }
    }

    const handleBack = () => {
        if (isWhyJoin) {
            setIsWhyJoin(false);
        } else if (isLocation) {
            setIsLocation(false);
        } else if (isDesignation) {
            setIsDesignation(false);
        } else if (isInstitutionName) {
            setIsInstitutionName(false);
        } else if (isNumber) {
            setIsNumber(false);
        } else if (isFounderName) {
            setIsFounderName(false);
        } else if (isEmail) {
            setIsEmail(false);
        }
    }

    const loadScript = async (src) => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = src;
            script.onload = resolve;
            document.body.appendChild(script);
        });
    }

    const handleSubmit = async () => {
        try {
            const { data } = await axios.post(
                API.PAYMENT_BASE_URL + API.PAYMENT,
                {
                    userCount: 1, subscriptionType: "", pageType: "surgeColleges", packageType: "", redirectLink: "",
                    // userCount: 1, subscriptionType: "monthly", pageType: "startupPricing", packageType: "testing", redirectLink: "", 
                },
            );
            if (data === "nodomain") {
                alert("Domain url wrong");
                window.location.href = "/404";
            }
            else if (data?.statusCode === 200) {
                razorPayment(data?.data);
                updateOrderId(data?.data?.id)
            }
        } catch (err) {
            var statusCode = err?.response?.status;
            console.log(statusCode);
        }
    };

    const updateOrderId = async (value) => {
        try {
            // --- API Call ---
            const { data } = await axios.post(API.BASE_URL + API.UPDATE_ORDER_ID, {
                email,
                orderId: value,
            });

            if (data?.statusCode === 200) {
                // setIsSuccess(true);
                console.log(data);
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || "Something went wrong. Please try again.", {
                position: "top-right",
                autoClose: 3000,
            });
        }
    };

    const razorPayment = async (purchaseData) => {
        if (!scriptLoaded) {
            await loadScript('https://checkout.razorpay.com/v1/checkout.js'); // Load the Razorpay script dynamically
            setScriptLoaded(true);
        }

        const options = {
            key: API.KEY, // Replace with your actual Razorpay API key
            amount: purchaseData?.totalAmt, // Amount in paise (e.g., 10000 paise = <span className="avenirnext">₹ </span>100)
            currency: 'INR',
            // name: "ACTC Events",
            description: 'Workfast Deals',
            // image: purchaseData?.shopImage,
            order_id: purchaseData?.id, // Replace with the generated order ID from your server
            // callback_url: API.PAYMENT_SUCCESS,
            handler: async (response) => {
                handlePaySubmit();
                try {
                    const res = await axios.post(API.PAYMENT_BASE_URL + API.TICKET_SUCCESS, {
                        ...response,
                    });
                    if (res.data.success) {
                        console.log("Payment Success");
                    }
                } catch (err) {
                    var statusCode = err?.response?.status;
                    console.log(statusCode);
                }
            },
            notes: {
                purchaseId: purchaseData?.id
            },
            prefill: {
                // email: email,
                // contact: phoneNumber,
                // 'method': 'card' //netbanking|card|upi|wallet
            },
            modal: {
                ondismiss: async () => {
                    await axios.post(API.PAYMENT_BASE_URL + API.PAYMENT_CLOSED, { id: purchaseData?.id });
                    setIsPay(false)
                    setIsDate(false)
                },
            },
            theme: {
                color: "#560095"
            },
            config: {
                display: {
                    hide: [
                        { method: 'paylater' },
                        { method: 'emi' },
                        { method: 'cardless_emi' },
                        { method: 'upi' },
                    ],
                }
            }
        };

        const razorpay = new window.Razorpay(options);
        razorpay.open();
    };

    const handleEmailSubmit = async (e) => {
        try {
            const { data } = await axios.post(API.BASE_URL + API.BOOK_SLOT,
                {
                    email: email,
                }
            );
            if (data?.statusCode === 200) {
                setIsEmail(true);
                setIsEmailEnter(true);
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error || "Something went wrong. Please try again.";
            if (errorMessage === "ALREADY_REGISTERED") {
                setIsAlready(true)
            } else {
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                });
            }
        }
    }

    const handleNameSubmit = async (e) => {
        try {
            const { data } = await axios.post(API.BASE_URL + API.UPDATE_SLOT,
                {
                    email: email,
                    name: founderName,
                }
            );
            if (data?.statusCode === 200) {
                setIsFounderName(true);
                setIsFounderNameEnter(true)
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error || "Something went wrong. Please try again.";
            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
            });
        }
    }

    const handleNumberSubmit = async (e) => {
        try {
            const { data } = await axios.post(API.BASE_URL + API.UPDATE_SLOT,
                {
                    email: email,
                    mobile: number,
                }
            );
            if (data?.statusCode === 200) {
                setIsNumber(true);
                setIsNumberEnter(true)
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error || "Something went wrong. Please try again.";
            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
            });
        }
    }

    const handleCompanyNameSubmit = async (e) => {
        try {
            const { data } = await axios.post(API.BASE_URL + API.UPDATE_SLOT,
                {
                    email: email,
                    institutionName: institutionName,
                }
            );
            if (data?.statusCode === 200) {
                setIsInstitutionName(true);
                setIsInstitutionNameEnter(true)
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error || "Something went wrong. Please try again.";
            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
            });
        }
    }

    const handleRoleSubmit = async (e) => {
        try {
            const { data } = await axios.post(API.BASE_URL + API.UPDATE_SLOT,
                {
                    email: email,
                    designation: designation,
                }
            );
            if (data?.statusCode === 200) {
                setIsDesignation(true);
                setIsDesignationEnter(true)
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error || "Something went wrong. Please try again.";
            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
            });
        }
    }

    const handleNolicencesSubmit = async (e) => {
        try {
            const { data } = await axios.post(API.BASE_URL + API.UPDATE_SLOT,
                {
                    email: email,
                    meetingDate: date,
                }
            );
            if (data?.statusCode === 200) {
                setIsDate(true);
                setIsDateEnter(true);
                handleSubmit()
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error || "Something went wrong. Please try again.";
            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
            });
        }
    }

    const handleStartSubmit = async (e) => {
        try {
            const { data } = await axios.post(API.BASE_URL + API.UPDATE_SLOT,
                {
                    email: email,
                    wishToJoin: whyJoin,
                }
            );
            if (data?.statusCode === 200) {
                setIsWhyJoin(true);
                setIsWhyJoinEnter(true)
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error || "Something went wrong. Please try again.";
            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
            });
        }
    }

    const handleAdditionalSubmit = async (e) => {
        try {
            const { data } = await axios.post(API.BASE_URL + API.UPDATE_SLOT,
                {
                    email: email,
                    location: location,
                }
            );
            if (data?.statusCode === 200) {
                setIsLocation(true);
                setIsLocationEnter(true);
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error || "Something went wrong. Please try again.";
            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
            });
        }
    }

    const handlePaySubmit = async (e) => {
        try {
            const { data } = await axios.post(API.BASE_URL + API.UPDATE_SLOT,
                {
                    email: email,
                    payment: "Yes",
                }
            );
            if (data?.statusCode === 200) {
                setIsPay(true);
                setIsDate(true);
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error || "Something went wrong. Please try again.";
            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
            });
        }
    }

    const handleSlotSubmit = async (value) => {
        try {
            const { data } = await axios.post(API.BASE_URL + API.UPDATE_SLOT,
                {
                    email: email,
                    package: value,
                }
            );
            if (data?.statusCode === 200) {
                setIsSuccess(true)
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error || "Something went wrong. Please try again.";
            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
            });
        }
    }

    return (
        <div className={`p-[20px] md:p-[50px] w-full h-screen flex flex-col gap-[30px]`}>
            <div className='w-full'>
                <div className='flex justify-between items-start w-full'>
                    <div className='text-[#080808] text-[22px] md:text-[28px] font-semibold'>
                        <h1>Surge Colleges Application</h1>
                        <h2 className='mt-[7px] text-[16px] md:text-[22px] text-[#000000] font-normal'>To book your slot, pay a refundable token of ₹1000 + GST. This amount will be adjusted/refunded once you successfully onboard as a Client.</h2>
                        <h3 className='mt-[7px] text-[12px] md:text-[18px] text-[#000000] font-normal'>(This ensures only serious applicants proceed.)</h3>
                    </div>
                    <RxCross2 className='text-[20px] md:text-[30px] cursor-pointer flex-shrink-0' onClick={() => { window.location.href = "/surge-colleges" }} />
                </div>
                <div className="grid gap-[10px] py-[10px] grid-cols-8">
                    <div className='w-full bg-[#AEAEB2] h-[6px] rounded-full transition-all'>
                        <div className={`h-full bg-[#FF3B30] transition-all duration-500 ease-in-out ${isEmail ? "w-full rounded-full" : "w-1/2 rounded-l-full"}`}></div>
                    </div>
                    <div className='w-full bg-[#AEAEB2] h-[6px] rounded-full transition-all'>
                        <div className={`h-full bg-[#FF9500] transition-all duration-500 ease-in-out ${isFounderName ? "w-full rounded-full" : isEmail ? "w-1/2 rounded-l-full" : "w-0"}`}></div>
                    </div>
                    <div className='w-full bg-[#AEAEB2] h-[6px] rounded-full transition-all'>
                        <div className={`h-full bg-[#bdc734] transition-all duration-500 ease-in-out ${isNumber ? "w-full rounded-full" : isFounderName ? "w-1/2 rounded-l-full" : "w-0"}`}></div>
                    </div>
                    <div className='w-full bg-[#AEAEB2] h-[6px] rounded-full transition-all'>
                        <div className={`h-full bg-[#34C759] transition-all duration-500 ease-in-out ${isInstitutionName ? "w-full rounded-full" : isNumber ? "w-1/2 rounded-l-full" : "w-0"}`}></div>
                    </div>
                    <div className='w-full bg-[#AEAEB2] h-[6px] rounded-full transition-all'>
                        <div className={`h-full bg-[#00C7BE] transition-all duration-500 ease-in-out ${isDesignation ? "w-full rounded-full" : isInstitutionName ? "w-1/2 rounded-l-full" : "w-0"}`}></div>
                    </div>
                    <div className='w-full bg-[#AEAEB2] h-[6px] rounded-full transition-all'>
                        <div className={`h-full bg-[#e6327d] transition-all duration-500 ease-in-out ${isLocation ? "w-full rounded-full" : isDesignation ? "w-1/2 rounded-l-full" : "w-0"}`}></div>
                    </div>
                    <div className='w-full bg-[#AEAEB2] h-[6px] rounded-full transition-all'>
                        <div className={`h-full bg-[#007AFF] transition-all duration-500 ease-in-out ${isWhyJoin ? "w-full rounded-full" : isLocation ? "w-1/2 rounded-l-full" : "w-0"}`}></div>
                    </div>
                    <div className='w-full bg-[#AEAEB2] h-[6px] rounded-full transition-all'>
                        <div className={`h-full bg-[#5d00ff] transition-all duration-500 ease-in-out ${(isDate && isPay) ? "w-full rounded-full" : isWhyJoin ? "w-1/2 rounded-l-full" : "w-0"}`}></div>
                    </div>
                    {/* <div className='w-full bg-[#AEAEB2] h-[6px] rounded-full transition-all'>
                        <div className={`h-full bg-[#ff00dd] transition-all duration-500 ease-in-out ${isPackage ? "w-full rounded-full" : (isDate && isPay) ? "w-1/2 rounded-l-full" : "w-0"}`}></div>
                    </div> */}
                </div>
            </div>
            <div className={`flex justify-start w-full h-full ${isDate ? "items-start overflow-y-scroll" : "items-center overflow-hidden"}`}>

                {/* ---- email ---- */}
                <div className={`min-w-full transition-all ease-in-out duration-500 mx-auto  ${isEmail ? "opacity-0 -translate-x-[100%]" : ""}`}>
                    <div className='md:w-[70%] mx-auto'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#34C75933] size-[32px] md:size-[44px] rounded-[10px] flex justify-center items-center text-[16px] md:text-[22px] text-[#34C759]'>
                                <IoIosMail />
                            </div>
                            <div className='text-[#080808] text-[16px] md:text-[20px] font-medium'>Email<span className='text-[#FFDD09]'>* </span></div>
                        </div>
                        <div className='mt-[14px] w-full border border-[#E8E8E8] rounded-[10px] md:rounded-[16px] px-[11px] py-[10px] md:py-[15px]'>
                            <input type='email' value={email} placeholder='Enter your email' className='max-w-full w-full bg-transparent text-[18px] md:text-[22px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setEmail(e.target.value); setEmailError('') }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault(); // stops form auto-submit
                                        handleNext();
                                    }
                                }}
                            />
                        </div>
                        {emailError && (
                            <div className='mt-[16px] w-full flex gap-4 items-center'>
                                <div className='bg-[#f7e6e6] min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <TbAlertTriangleFilled className='text-[#af0404] w-4 h-4' />
                                    <h3 className='text-[#af0404] text-sm'>{emailError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* ---- Founder name ----  */}
                <div className={`min-w-full transition-all ease-in-out duration-500 mx-auto  ${isFounderName ? "opacity-0 -translate-x-[200%]" : isEmail ? "opacity-1 -translate-x-[100%]" : ""}`}>
                    <div className='md:w-[70%] mx-auto'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#FF3B3033] size-[32px] md:size-[44px] rounded-[10px] flex justify-center items-center text-[12px] md:text-[18px] text-[#FF3B30]'>
                                <FaUser />
                            </div>
                            <div className='text-[#080808] text-[16px] md:text-[20px] font-medium'>Full Name <span className='text-[#FFDD09]'>* </span></div>
                        </div>
                        <div className='mt-[14px] w-full border border-[#E8E8E8] rounded-[10px] md:rounded-[16px] px-[11px] py-[10px] md:py-[15px]'>
                            <input type='text' value={founderName} placeholder='Enter your full name' className='max-w-full w-full bg-transparent text-[18px] md:text-[22px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setFounderName(e.target.value); setFounderNamError('') }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault(); // stops form auto-submit
                                        handleNext();
                                    }
                                }}
                            />
                        </div>
                        {founderNameError && (
                            <div className='mt-[16px] w-full flex gap-4 items-center'>
                                <div className='bg-[#f7e6e6] min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <TbAlertTriangleFilled className='text-[#af0404] w-4 h-4' />
                                    <h3 className='text-[#af0404] text-sm'>{founderNameError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* ---- Number ---- */}
                <div className={`min-w-full transition-all ease-in-out duration-500 mx-auto  ${isNumber ? "opacity-0 -translate-x-[300%]" : isFounderName ? "opacity-1 -translate-x-[200%]" : isEmail ? "opacity-0 -translate-x-[100%]" : ""}`}>
                    <div className='md:w-[70%] mx-auto'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#00C7BE33] size-[32px] md:size-[44px] rounded-[10px] flex justify-center items-center text-[12px] md:text-[18px] text-[#00C7BE]'>
                                <FaPhone />
                            </div>
                            <div className='text-[#080808] text-[16px] md:text-[20px] font-medium'>Phone<span className='text-[#FFDD09]'>* </span></div>
                        </div>
                        <div className='mt-[14px] w-full border border-[#E8E8E8] rounded-[10px] md:rounded-[16px] px-[11px] py-[10px] md:py-[15px]'
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault(); // stops form auto-submit
                                    handleNext();
                                }
                            }}
                        >
                            <PhoneInput defaultCountry="in" value={number} onChange={(phone, country) => { setNumber(phone); setCountryCode(country?.country); setNumberError(''); }} className="max-h-[40px] sm:max-h-[60px] h-full w-full focus:outline-none cursor-pointer surge-form placeholder:text-[#000]" />
                        </div>
                        {numberError && (
                            <div className='mt-[16px] w-full flex gap-4 items-center'>
                                <div className='bg-[#f7e6e6] min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <TbAlertTriangleFilled className='text-[#af0404] w-4 h-4' />
                                    <h3 className='text-[#af0404] text-sm'>{numberError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* ---- Institution name ---- */}
                <div className={`min-w-full transition-all ease-in-out duration-500 mx-auto  ${isInstitutionName ? "opacity-0 -translate-x-[400%]" : isNumber ? "opacity-1 -translate-x-[300%]" : isFounderName ? "opacity-0 -translate-x-[200%]" : isEmail ? "opacity-0 -translate-x-[100%]" : ""}`}>
                    <div className='md:w-[70%] mx-auto'>
                        <div className='flex justify-between items-center'>
                            <div className='flex gap-[10px] items-center'>
                                <div className='bg-[#FF950033] size-[32px] md:size-[44px] rounded-[10px] flex justify-center items-center text-[16px] md:text-[22px] text-[#FF9500]'>
                                    <HiOutlineBars3 />
                                </div>
                                <div className='text-[#080808] text-[16px] md:text-[20px] font-medium'>Name of the Institution *</div>
                            </div>
                        </div>
                        <div className='mt-[14px] w-full border border-[#E8E8E8] rounded-[10px] md:rounded-[16px] px-[11px] py-[10px] md:py-[15px]'>
                            <input type='text' value={institutionName} placeholder='Enter your Institution Name' className='max-w-full w-full bg-transparent text-[18px] md:text-[22px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setInstitutionName(e.target.value); setInstitutionNameError('') }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault(); // stops form auto-submit
                                        handleNext();
                                    }
                                }}
                            />
                        </div>
                        {institutionNameError && (
                            <div className='mt-[16px] w-full flex gap-4 items-center'>
                                <div className='bg-[#f7e6e6] min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <TbAlertTriangleFilled className='text-[#af0404] w-4 h-4' />
                                    <h3 className='text-[#af0404] text-sm'>{institutionNameError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* ---- Designation ---- */}
                <div className={`min-w-full transition-all ease-in-out duration-500 mx-auto  ${isDesignation ? "opacity-0 -translate-x-[500%]" : isInstitutionName ? "opacity-1 -translate-x-[400%]" : isNumber ? "opacity-0 -translate-x-[300%]" : isFounderName ? "opacity-0 -translate-x-[200%]" : isEmail ? "opacity-0 -translate-x-[100%]" : ""}`}>
                    <div className='md:w-[70%] mx-auto'>
                        <div className='flex justify-between items-center'>
                            <div className='flex gap-[10px] items-center'>
                                <div className='bg-[#FF950033] size-[32px] md:size-[44px] rounded-[10px] flex justify-center items-center text-[16px] md:text-[22px] text-[#FF9500]'>
                                    <HiOutlineBars3 />
                                </div>
                                <div className='text-[#080808] text-[16px] md:text-[20px] font-medium'>Designation *</div>
                            </div>
                        </div>
                        <div className='mt-[14px] w-full border border-[#E8E8E8] rounded-[10px] md:rounded-[16px] px-[11px] py-[10px] md:py-[15px]'>
                            <input type='text' value={designation} placeholder='Enter your Designation' className='max-w-full w-full bg-transparent text-[18px] md:text-[22px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setDesignation(e.target.value); setDesignationError('') }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault(); // stops form auto-submit
                                        handleNext();
                                    }
                                }}
                            />
                        </div>
                        {designationError && (
                            <div className='mt-[16px] w-full flex gap-4 items-center'>
                                <div className='bg-[#f7e6e6] min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <TbAlertTriangleFilled className='text-[#af0404] w-4 h-4' />
                                    <h3 className='text-[#af0404] text-sm'>{designationError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* ---- Location ---- */}
                <div className={`min-w-full transition-all ease-in-out duration-500 mx-auto  ${isLocation ? "opacity-0 -translate-x-[600%]" : isDesignation ? "opacity-1 -translate-x-[500%]" : isInstitutionName ? "opacity-0 -translate-x-[400%]" : isNumber ? "opacity-0 -translate-x-[300%]" : isFounderName ? "opacity-0 -translate-x-[200%]" : isEmail ? "opacity-0 -translate-x-[100%]" : ""}`}>
                    <div className='md:w-[70%] mx-auto'>
                        <div className='flex justify-between items-center'>
                            <div className='flex gap-[10px] items-center'>
                                <div className='bg-[#FF950033] size-[32px] md:size-[44px] rounded-[10px] flex justify-center items-center text-[16px] md:text-[22px] text-[#FF9500]'>
                                    <HiOutlineBars3 />
                                </div>
                                <div className='text-[#080808] text-[16px] md:text-[20px] font-medium'>Location</div>
                            </div>
                        </div>
                        <div className='mt-[14px] w-full border border-[#E8E8E8] rounded-[10px] md:rounded-[16px] px-[11px] py-[10px] md:py-[15px]'>
                            <input type='text' value={location} placeholder='Enter your Location' className='max-w-full w-full bg-transparent text-[18px] md:text-[22px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setLocation(e.target.value); setlocationError("") }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault(); // stops form auto-submit
                                        handleNext();
                                    }
                                }} />
                        </div>
                        {locationError && (
                            <div className='mt-[16px] w-full flex gap-4 items-center'>
                                <div className='bg-[#f7e6e6] min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <TbAlertTriangleFilled className='text-[#af0404] w-4 h-4' />
                                    <h3 className='text-[#af0404] text-sm'>{locationError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* ---- Why Join ---- */}
                <div className={`min-w-full transition-all ease-in-out duration-500 mx-auto  ${isWhyJoin ? "opacity-0 -translate-x-[700%]" : isLocation ? "opacity-1 -translate-x-[600%]" : isDesignation ? "opacity-0 -translate-x-[500%]" : isInstitutionName ? "opacity-0 -translate-x-[400%]" : isNumber ? "opacity-0 -translate-x-[300%]" : isFounderName ? "opacity-0 -translate-x-[200%]" : isEmail ? "opacity-0 -translate-x-[100%]" : ""}`}>
                    <div className='md:w-[70%] mx-auto'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#FFDD0933] size-[32px] md:size-[44px] rounded-[10px] flex justify-center items-center text-[12px] md:text-[18px] text-[#6C5D00] shrink-0'>
                                <FaUser />
                            </div>
                            <div className='text-[#080808] text-[16px] md:text-[20px] font-medium'>why do you wish to join surge colleges? *</div>
                        </div>
                        <div className='mt-[32px] w-full flex flex-col max-w-full min-w-[168px] items-stretch'>
                            <div className={`mb-2 w-[300px] relative flex items-start sm:items-center rounded-[4px] bg-[#000] hover:bg-[#474747] text-[#000] min-h-[40px] py-1 break-words cursor-pointer opacity-1 shadow-radio border-[#FFDD09] ${whyJoin === "Internships" ? "border-[1px]" : ""}`} onClick={() => { if (whyJoin === "Internships") { setWhyJoin(""); } else { setWhyJoin("Internships"); setWhyJoinError('') } }}>
                                <div className={`my-1 mx-2 w-6 h-6 min-h-[22px] shrink-0 rounded-[2px] text-xs  border-[1px] flex justify-center items-center ${whyJoin === "Internships" ? "bg-[#e6e6e6] text-[#0d0601] border-[#FFDD09]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>A</span>
                                </div>
                                <h3 className='w-full min-w-[100px] text-start break-word text-[16px] sm:text-[20px] text-[#e6e6e6] my-auto'>Internships</h3>
                                {whyJoin === "Internships" && (
                                    <IoMdCheckmark className='text-[#e6e6e6] my-auto text-end text-[20px] sm:text-[24px] mr-2' />
                                )}
                            </div>
                            <div className={`mb-2 w-[300px] relative flex items-start sm:items-center rounded-[4px] bg-[#000] hover:bg-[#474747] text-[#000] min-h-[40px] py-1 break-words cursor-pointer opacity-1 shadow-radio border-[#FFDD09] ${whyJoin === "Scaling the Institutions" ? "border-[2px]" : ""}`} onClick={() => { if (whyJoin === "Scaling the Institutions") { setWhyJoin(""); } else { setWhyJoin("Scaling the Institutions"); setWhyJoinError('') } }}>
                                <div className={`my-1 mx-2 w-6 h-6 min-h-[22px] shrink-0 rounded-[2px] text-xs border-[1px] flex justify-center items-center ${whyJoin === "Scaling the Institutions" ? "bg-[#e6e6e6] text-[#0d0601] border-[#FFDD09]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>B</span>
                                </div>
                                <h3 className='w-full min-w-[100px] text-start break-word text-[16px] sm:text-[20px] text-[#e6e6e6] my-auto'>Scaling the Institutions</h3>
                                {whyJoin === "Scaling the Institutions" && (
                                    <IoMdCheckmark className='text-[#e6e6e6] my-auto text-end text-[20px] sm:text-[24px] mr-2' />
                                )}
                            </div>
                            <div className={`mb-2 w-[300px] relative flex items-start sm:items-center rounded-[4px] bg-[#000] hover:bg-[#474747] text-[#000] min-h-[40px] py-1 break-words cursor-pointer opacity-1 shadow-radio border-[#FFDD09] ${whyJoin === "Start Up Ecosystem" ? "border-[1px]" : ""}`} onClick={() => { if (whyJoin === "Start Up Ecosystem") { setWhyJoin(""); } else { setWhyJoin("Start Up Ecosystem"); setWhyJoinError('') } }}>
                                <div className={`my-1 mx-2 w-6 h-6 min-h-[22px] shrink-0 rounded-[2px] text-xs border-[1px] flex justify-center items-center ${date === "Start Up Ecosystem" ? "bg-[#e6e6e6] text-[#0d0601] border-[#FFDD09]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>C</span>
                                </div>
                                <h3 className='w-full min-w-[100px] text-start break-word text-[16px] sm:text-[20px] text-[#e6e6e6] my-auto'>Start Up Ecosystem</h3>
                                {whyJoin === "Start Up Ecosystem" && (
                                    <IoMdCheckmark className='text-[#e6e6e6] my-auto text-end text-[20px] sm:text-[24px] mr-2' />
                                )}
                            </div>
                            <div className={`mb-2 w-[300px] relative flex items-start sm:items-center rounded-[4px] bg-[#000] hover:bg-[#474747] text-[#000] min-h-[40px] py-1 break-words cursor-pointer opacity-1 shadow-radio border-[#FFDD09] ${whyJoin === "Training & Developement" ? "border-[1px]" : ""}`} onClick={() => { if (whyJoin === "Training & Developement") { setWhyJoin(""); } else { setWhyJoin("Training & Developement"); setWhyJoinError('') } }}>
                                <div className={`my-1 mx-2 w-6 h-6 min-h-[22px] shrink-0 rounded-[2px] text-xs border-[1px] flex justify-center items-center ${whyJoin === "Training & Developement" ? "bg-[#e6e6e6] text-[#0d0601] border-[#FFDD09]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>D</span>
                                </div>
                                <h3 className='w-full min-w-[100px] text-start break-word text-[16px] sm:text-[20px] text-[#e6e6e6] my-auto'>Training & Developement</h3>
                                {whyJoin === "Training & Developement" && (
                                    <IoMdCheckmark className='text-[#e6e6e6] my-auto text-end text-[20px] sm:text-[24px] mr-2' />
                                )}
                            </div>
                            <div className={`mb-2 w-[300px] relative flex items-start sm:items-center rounded-[4px] bg-[#000] hover:bg-[#474747] text-[#000] min-h-[40px] py-1 break-words cursor-pointer opacity-1 shadow-radio border-[#FFDD09] ${whyJoin === "Networking with Industry Experts" ? "border-[1px]" : ""}`} onClick={() => { if (whyJoin === "Networking with Industry Experts") { setWhyJoin(""); } else { setWhyJoin("Networking with Industry Experts"); setWhyJoinError('') } }}>
                                <div className={`my-1 mx-2 w-6 h-6 min-h-[22px] shrink-0 rounded-[2px] text-xs  border-[1px] flex justify-center items-center ${whyJoin === "Networking with Industry Experts" ? "bg-[#e6e6e6] text-[#0d0601] border-[#FFDD09]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>E</span>
                                </div>
                                <h3 className='w-full min-w-[100px] text-start break-word text-[16px] sm:text-[20px] text-[#e6e6e6] my-auto'>Networking with Industry Experts</h3>
                                {whyJoin === "Networking with Industry Experts" && (
                                    <IoMdCheckmark className='text-[#e6e6e6] my-auto text-end text-[20px] sm:text-[24px] mr-2' />
                                )}
                            </div>
                        </div>
                        {whyJoinError && (
                            <div className='mt-[16px] w-full flex gap-4 items-center'>
                                <div className='bg-[#f7e6e6] min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <TbAlertTriangleFilled className='text-[#af0404] w-4 h-4' />
                                    <h3 className='text-[#af0404] text-sm'>{whyJoinError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* ---- Date ---- */}
                <div className={`min-w-full transition-all ease-in-out duration-500 mx-auto  ${(isDate && isPay) ? "opacity-0 -translate-x-[800%]" : isWhyJoin ? "opacity-1 -translate-x-[700%]" : isLocation ? "opacity-0 -translate-x-[600%]" : isDesignation ? "opacity-0 -translate-x-[500%]" : isInstitutionName ? "opacity-0 -translate-x-[400%]" : isNumber ? "opacity-0 -translate-x-[300%]" : isFounderName ? "opacity-0 -translate-x-[200%]" : isEmail ? "opacity-0 -translate-x-[100%]" : ""}`}>
                    <div className='md:w-[70%] mx-auto'>
                        <div className='flex justify-between items-center'>
                            <div className='flex gap-[10px] items-center'>
                                <div className='bg-[#FF950033] size-[32px] md:size-[44px] rounded-[10px] flex justify-center items-center text-[16px] md:text-[22px] text-[#FF9500] shrink-0'>
                                    <HiOutlineBars3 />
                                </div>
                                <div className='text-[#080808] text-[16px] md:text-[20px] font-medium'>Tentative date for meeting*</div>
                            </div>
                        </div>
                        <div className='mt-[32px] w-full flex flex-col max-w-full min-w-[168px] items-stretch'>
                            <div className={`mb-2 w-[300px] relative flex items-start sm:items-center rounded-[4px] bg-[#000] hover:bg-[#474747] text-[#000] min-h-[40px] py-1 break-words cursor-pointer opacity-1 shadow-radio border-[#FFDD09] ${date === "Nov 3-7th" ? "border-[1px]" : ""}`} onClick={() => { if (date === "Nov 3-7th") { setDate(""); } else { setDate("Nov 3-7th"); setDateError('') } }}>
                                <div className={`my-1 mx-2 w-6 h-6 min-h-[22px] shrink-0 rounded-[2px] text-xs  border-[1px] flex justify-center items-center ${date === "Nov 3-7th" ? "bg-[#e6e6e6] text-[#0d0601] border-[#FFDD09]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>A</span>
                                </div>
                                <h3 className='w-full min-w-[100px] text-start break-word text-[16px] sm:text-[20px] text-[#e6e6e6] my-auto'>Nov 3-7th</h3>
                                {date === "Nov 3-7th" && (
                                    <IoMdCheckmark className='text-[#e6e6e6] my-auto text-end text-[20px] sm:text-[24px] mr-2' />
                                )}
                            </div>
                            <div className={`mb-2 w-[300px] relative flex items-start sm:items-center rounded-[4px] bg-[#000] hover:bg-[#474747] text-[#000] min-h-[40px] py-1 break-words cursor-pointer opacity-1 shadow-radio border-[#FFDD09] ${date === "Nov 10-14th" ? "border-[2px]" : ""}`} onClick={() => { if (date === "Nov 10-14th") { setDate(""); } else { setDate("Nov 10-14th"); setDateError('') } }}>
                                <div className={`my-1 mx-2 w-6 h-6 min-h-[22px] shrink-0 rounded-[2px] text-xs border-[1px] flex justify-center items-center ${date === "Nov 10-14th" ? "bg-[#e6e6e6] text-[#0d0601] border-[#FFDD09]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>B</span>
                                </div>
                                <h3 className='w-full min-w-[100px] text-start break-word text-[16px] sm:text-[20px] text-[#e6e6e6] my-auto'>Nov 10-14th</h3>
                                {date === "Nov 10-14th" && (
                                    <IoMdCheckmark className='text-[#e6e6e6] my-auto text-end text-[20px] sm:text-[24px] mr-2' />
                                )}
                            </div>
                            <div className={`mb-2 w-[300px] relative flex items-start sm:items-center rounded-[4px] bg-[#000] hover:bg-[#474747] text-[#000] min-h-[40px] py-1 break-words cursor-pointer opacity-1 shadow-radio border-[#FFDD09] ${date === "Nov 17-21st" ? "border-[1px]" : ""}`} onClick={() => { if (date === "Nov 17-21st") { setDate(""); } else { setDate("Nov 17-21st"); setDateError('') } }}>
                                <div className={`my-1 mx-2 w-6 h-6 min-h-[22px] shrink-0 rounded-[2px] text-xs border-[1px] flex justify-center items-center ${date === "Nov 17-21st" ? "bg-[#e6e6e6] text-[#0d0601] border-[#FFDD09]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>C</span>
                                </div>
                                <h3 className='w-full min-w-[100px] text-start break-word text-[16px] sm:text-[20px] text-[#e6e6e6] my-auto'>Nov 17-21st</h3>
                                {date === "Nov 17-21st" && (
                                    <IoMdCheckmark className='text-[#e6e6e6] my-auto text-end text-[20px] sm:text-[24px] mr-2' />
                                )}
                            </div>
                            <div className={`mb-2 w-[300px] relative flex items-start sm:items-center rounded-[4px] bg-[#000] hover:bg-[#474747] text-[#000] min-h-[40px] py-1 break-words cursor-pointer opacity-1 shadow-radio border-[#FFDD09] ${date === "Nov 24th-28th" ? "border-[1px]" : ""}`} onClick={() => { if (date === "Nov 24th-28th") { setDate(""); } else { setDate("Nov 24th-28th"); setDateError('') } }}>
                                <div className={`my-1 mx-2 w-6 h-6 min-h-[22px] shrink-0 rounded-[2px] text-xs border-[1px] flex justify-center items-center ${date === "Nov 24th-28th" ? "bg-[#e6e6e6] text-[#0d0601] border-[#FFDD09]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>D</span>
                                </div>
                                <h3 className='w-full min-w-[100px] text-start break-word text-[16px] sm:text-[20px] text-[#e6e6e6] my-auto'>Nov 24th-28th</h3>
                                {date === "Nov 24th-28th" && (
                                    <IoMdCheckmark className='text-[#e6e6e6] my-auto text-end text-[20px] sm:text-[24px] mr-2' />
                                )}
                            </div>
                        </div>
                        {dateError && (
                            <div className='mt-[16px] w-full flex gap-4 items-center'>
                                <div className='bg-[#f7e6e6] min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <TbAlertTriangleFilled className='text-[#af0404] w-4 h-4' />
                                    <h3 className='text-[#af0404] text-sm'>{dateError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* ---- Package ---- */}
                <div className={`min-w-full transition-all ease-in-out duration-500 mx-auto  ${(isDate && isPay) ? "opacity-1 -translate-x-[800%]" : isWhyJoin ? "opacity-1 -translate-x-[700%]" : isLocation ? "opacity-0 -translate-x-[600%]" : isDesignation ? "opacity-0 -translate-x-[500%]" : isInstitutionName ? "opacity-0 -translate-x-[400%]" : isNumber ? "opacity-0 -translate-x-[300%]" : isFounderName ? "opacity-0 -translate-x-[200%]" : isEmail ? "opacity-0 -translate-x-[100%]" : ""}`}>
                    <div className='relative flex justify-center items-center  w-fit mx-auto mt-[20px]'>
                        <h3 className='text-[#180833] font-bold text-[20px] md:text-[32px] text-center relative z-[1]'>Surge Colleges Packages & Pricing</h3>
                        <img src="https://nxtgenac.com/webassets/images/pricing/paint.png" alt='paint' className='absolute -left-[20px] sm:-left-[40px]' />
                    </div>
                    {/* <p className='text-[#180833] font-medium text-[14px] sm:text-[20px] lg:text-[26px] mt-[10px] text-center'>We offer flexible franchise packages designed for entrepreneurs at every level. Each package includes <br className='hidden xl:block' /> annual franchise rights, training, sales kit, certification, and ongoing support.</p> */}
                    <div className='mt-[20px]'>
                        <div className='mt-[20px] md:w-11/12 xl:w-10/12 mx-auto grid sm:grid-cols-2 xl:grid-cols-3 gap-[15px]'>
                            {plans.map((ea, index) => (
                                <div key={index} className={`p-[16px] bg-[#f8fcfe] rounded-[12px] flex flex-col items-center text-center relative border-[#1fbefd] border`} >
                                    <img src={ea.icon} alt={ea?.title} className='size-[100px] md:size-[130px]' />
                                    <div className='mt-[4px] md:mt-[8px]'>
                                        <p className='text-[#1F2329] text-[20px] md:text-[24px] font-bold'>{ea.title}</p>
                                        <p className='text-[#646A73] text-[16px] md:text-[20px] font-semibold mt-[2px] md:mt-[4px]'>{ea.subtitle}</p>
                                    </div>
                                    <div className='mt-[4px] md:mt-[8px]'>
                                        <p className='text-[#1F2329] text-[18px] sm:text-[24px] font-bold'>{ea.price}<span className='text-[16px] sm:text-[22px]'>/year</span></p>
                                        <button className='mt-[15px] w-full h-[36px] sm:h-[50px] bg-gradient-to-bl from-[#1fd4fd] via-[#2057fd] to-[#5a1bf8] rounded-full text-[#FFF] text-[15px] sm:text-[18px] font-semibold' onClick={() => { handleSlotSubmit(ea?.title) }}>Book Slot</button>
                                    </div>
                                    <div className='mt-[15px] sm:mt-[22px] text-[#000000] text-[16px] font-medium flex flex-col gap-[16px] items-start xl:w-11/12 mx-auto'>
                                        <div className='flex gap-[14px] items-start justify-center'>
                                            <RiGraduationCapLine size={20} className='mt-[1px] flex-shrink-0' />
                                            <p>{ea?.Internships} Internships (Guaranteed) </p>
                                        </div>
                                        <div className='flex gap-[14px] items-start justify-center text-start'>
                                            <RiShieldFlashLine size={20} className='mt-[1px] flex-shrink-0' />
                                            <p>{ea?.events} Hackathons/Events</p>
                                        </div>
                                        <div className='flex gap-[14px] items-start justify-center text-start'>
                                            <LuTarget size={20} className='mt-[1px] flex-shrink-0' />
                                            <p>{ea?.trainingProgram} Training Programs</p>
                                        </div>
                                        <div className='flex gap-[14px] items-start justify-center text-start'>
                                            <IoTrophyOutline size={20} className='mt-[1px] flex-shrink-0' />
                                            <p>{ea?.placement} Placement Power Ups</p>
                                        </div>
                                        <div className='flex gap-[14px] items-start justify-center text-start'>
                                            <LuHandshake size={20} className='mt-[2px] flex-shrink-0' />
                                            <p>{ea?.entrepreneurship}</p>
                                        </div>
                                        <div className='flex gap-[14px] items-start justify-center text-start'>
                                            <RiPresentationLine size={20} className='mt-[2px] flex-shrink-0' />
                                            <p>{ea?.facultyDevelopment}</p>
                                        </div>
                                        <div className='flex gap-[14px] items-start justify-center text-start'>
                                            <RiMedalLine size={20} className='mt-[2px] flex-shrink-0' />
                                            <p>{ea?.certifications} WF Certifications</p>
                                        </div>
                                        <div className='flex gap-[14px] items-start justify-center text-start'>
                                            <LuMic size={20} className='mt-[2px] flex-shrink-0' />
                                            <p>{ea?.lectures}</p>
                                        </div>
                                        <div className='flex gap-[14px] items-start justify-center text-start'>
                                            <LuSquareUserRound size={20} className='mt-[2px] flex-shrink-0' />
                                            <p>{ea?.HRs}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {!isPay && (
                <div className='grid md:flex gap-[25px] md:items-center md:justify-center w-full' >
                    <button className='border border-[#54545657] h-[40px] md:h-[55px] rounded-[18px] w-full md:w-[200px] lg:w-[380px] text-[#3C3C4399] font-semibold text-[20px] md:text-[24px]' disabled={!isEmail} onClick={() => { handleBack() }} >Back</button>
                    <button className='bg-[#FFDD09] h-[40px] md:h-[55px] rounded-[18px] md:w-[200px] w-full lg:w-[380px] text-[#000] font-semibold text-[20px] md:text-[24px]' onClick={() => { handleNext() }}>{isWhyJoin ? "Pay  ₹1000" : "Next"} <span className='text-[14px] md:text-[18px]'>{isWhyJoin ? "+18% GST" : ""}</span></button>
                </div>
            )}
            {isAlready && (
                <div className="bg-[#000]/[70%] fixed inset-0 z-[100] h-screen w-full flex justify-center items-center">
                    <div className='bg-[#FFF] w-11/12 md:w-1/2 max-h-[80vh] rounded-[24px] p-[20px] relative text-center'>
                        <div className="w-[100px] sm:w-[150px] lg:w-[200px] flex justify-center mx-auto">
                            {/* {isPaymentFailed ? (
                                <LoadLottie animationData={failed} loop={true} />
                            ) : ( */}
                            <LoadLottie animationData={sucess} loop={true} />
                            {/* )} */}
                        </div>
                        <div className='text-[24px] font-semibold'>This mail has already registered and completed all the process</div>
                        {/* <div className='text-[14px] font-normal'>Please try Again with another mail</div> */}
                        <button className='w-full h-[45px] font-semibold text-[16px] bg-[#FFDD09] rounded-md mt-[18px] text-[#000]' onClick={() => { setIsAlready(false) }}>Try Again</button>
                    </div>
                </div>
            )}
            {isSuccess && (
                <div className="bg-[#000]/[70%] fixed inset-0 z-[100] h-screen w-full flex justify-center items-center">
                    <div className='bg-[#FFF] w-11/12 md:w-1/2 max-h-[80vh] rounded-[24px] p-[20px] relative text-center'>
                        <div className="w-[100px] sm:w-[150px] lg:w-[200px] flex justify-center mx-auto">
                            {/* {isPaymentFailed ? (
                                <LoadLottie animationData={failed} loop={true} />
                            ) : ( */}
                            <LoadLottie animationData={sucess} loop={true} />
                            {/* )} */}
                        </div>
                        <div className='text-[24px] font-semibold'>You have successfully booked your slot.</div>
                        {/* <div className='text-[14px] font-normal'>Please try Again with another mail</div> */}
                        <button className='w-full h-[45px] font-semibold text-[16px] bg-[#FFDD09] rounded-md mt-[18px] text-[#000]' onClick={() => { window.location.href = "/" }}>Back Home</button>
                    </div>
                </div>
            )}
        </div>
    )
}
